"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBellOff1 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconBellOff1 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L5.14902 6.56323C5.05063 7.03229 4.99998 7.51361 4.99998 8.00011C4.99998 10.9128 4.26798 12.844 3.5006 14.0772L3.48876 14.0962C3.13146 14.6704 2.84899 15.1244 2.65857 15.4548C2.56315 15.6203 2.47622 15.7798 2.41186 15.9216C2.37973 15.9923 2.34379 16.0791 2.31569 16.1734C2.29239 16.2516 2.24799 16.4188 2.26463 16.6224C2.27582 16.7592 2.30372 16.9929 2.43787 17.2344C2.57202 17.4759 2.75575 17.6231 2.86599 17.7048C3.11628 17.8905 3.40371 17.933 3.49964 17.9471L3.50407 17.9478C3.65148 17.9696 3.81875 17.9805 3.98751 17.987C4.32272 18.0001 4.78679 18.0001 5.36391 18.0001H16.5859L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L6.99792 5.58371C6.97677 5.56045 6.95447 5.53814 6.93108 5.51687L3.70711 2.29289Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.6044 20.3383C8.96986 19.9242 9.6018 19.8848 10.0159 20.2503C10.5453 20.7176 11.2384 21 12 21C12.7615 21 13.4546 20.7176 13.9841 20.2503C14.3981 19.8848 15.0301 19.9242 15.3955 20.3383C15.761 20.7523 15.7216 21.3843 15.3075 21.7498C14.4267 22.5272 13.2673 23 12 23C10.7326 23 9.57322 22.5272 8.6924 21.7498C8.27834 21.3843 8.23893 20.7523 8.6044 20.3383Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.5306 17.2879C21.6554 17.0868 21.7162 16.8567 21.7353 16.6223C21.752 16.4187 21.7076 16.2515 21.6843 16.1733C21.6562 16.079 21.6202 15.9922 21.5881 15.9215C21.5237 15.7797 21.4368 15.6202 21.3414 15.4547C21.151 15.1243 20.8686 14.6705 20.5114 14.0965L20.4994 14.0771C19.732 12.8439 19 10.9127 19 8C19 6.14349 18.2625 4.36301 16.9497 3.05025C15.637 1.7375 13.8565 1 12 1C10.2007 1 8.47291 1.6927 7.17305 2.93041L21.5306 17.2879Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.63306 3.03371C9.61959 2.3649 10.791 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8C18 10.1008 18.2702 11.7512 18.6484 13.0324M6.25867 6.25724C6.08866 6.81726 6 7.40406 6 8C6 11.0902 5.22047 13.206 4.34966 14.6054C3.61513 15.7859 3.24786 16.3761 3.26132 16.5408C3.27624 16.7231 3.31486 16.7926 3.46178 16.9016C3.59446 17 4.19259 17 5.38885 17H17M9.35418 21C10.0593 21.6224 10.9856 22 12 22C13.0144 22 13.9407 21.6224 14.6458 21M21 21L3 3",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconBellOff1 = IconBellOff1;
//# sourceMappingURL=IconBellOff1.js.map